export default __webpack_public_path__ + "static/media/natein.bb7d5718.jpg";